import { useState } from "react";
import { Button } from "react-bootstrap";

import { FaWpforms } from "react-icons/fa";
import { GrTemplate } from "react-icons/gr";
import { LuFileSpreadsheet, LuMonitorCog } from "react-icons/lu";
import { RiContactsBook3Line, RiMailAiLine } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { GoProjectTemplate } from "react-icons/go";
import { IoCubeOutline, IoExtensionPuzzleOutline } from "react-icons/io5";

/* -------------------- MENU CONFIG -------------------- */

const CRM_SECTIONS = [
  {
    title: "Customer Relationship Management",
    items: [
      { key: "crmAnalytics", label: "Analytics", icon: <RxDashboard /> },
      { key: "crmForm", label: "Forms", icon: <FaWpforms /> },
      { key: "entries", label: "Entries", icon: <LuFileSpreadsheet /> },
      { key: "contacts", label: "Contacts", icon: <RiContactsBook3Line /> },
      { key: "formTemplates", label: "Form Templates", icon: <GrTemplate /> },
    ],
  },
  {
    title: "Mail Management",
    items: [
      { key: "manageMail", label: "Manage Mail", icon: <RiMailAiLine /> },
      { key: "mailMonitoring", label: "Mail Monitoring", icon: <LuMonitorCog /> },
      { key: "mailTemplates", label: "Mail Templates", icon: <GoProjectTemplate /> },
    ],
  },
];

/* -------------------- COMPONENT -------------------- */

const CRMSidebar = ({ openCRMModules, setOpenCRMModules }) => {
  const [showApps, setShowApps] = useState("");

  const handleModuleClick = (key) => {
    setOpenCRMModules(key);
    setShowApps("");
  };

  const handleBottomClick = (type) => {
    setShowApps(type);
    setOpenCRMModules("");
  };

  return (
    <>
      {/* Sidebar Menu */}
      <div className="overflow-auto" style={{ height: "calc(100vh - 80px)" }}>
        {CRM_SECTIONS.map((section) => (
          <div className="channels-section mb-4" key={section.title}>
            <div className="section-title px-2 fw-bold">
              <span>{section.title}</span>
            </div>

            <div className="px-2">
              {section.items.map((item) => (
                <div
                  key={item.key}
                  className={`channel-item mb-1 ${
                    openCRMModules === item.key ? "active" : ""
                  }`}
                  onClick={() => handleModuleClick(item.key)}
                >
                  <div className="hstack gap-2">
                    {item.icon}
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Buttons */}
      <div className="hstack border-top">
        <Button
          className="py-1 px-3 rounded-0 hstack gap-1 w-100 border-end-0"
          style={{ fontSize: 11 }}
          variant={showApps === "integration" ? "primary" : "outline-primary"}
          onClick={() => handleBottomClick("integration")}
        >
          <IoExtensionPuzzleOutline style={{ marginBottom: 3 }} />
          Integration
        </Button>

        <Button
          className="py-1 px-3 rounded-0 hstack gap-1 w-100"
          style={{ fontSize: 11 }}
          variant={showApps === "addon" ? "primary" : "outline-primary"}
          onClick={() => handleBottomClick("addon")}
        >
          <IoCubeOutline style={{ marginBottom: 3 }} />
          Add-ons
        </Button>
      </div>
    </>
  );
};

export default CRMSidebar;
